module.exports = __webpack_public_path__ + "img/Expo-Books-Coming-soon.9728de50.png";